import React from 'react';
import styled from 'styled-components';

import Bar from './../Bar';
import ModelRow from './ModelRow';
import { chunk } from '../../../helpers';

const ModelContainer = styled.div`
  margin: 0% 25px;
  padding-top: 30px;
  padding-bottom: 30px;
  overflow: hidden;
  width: 100%;

  @media print {
    margin: 0% 15px;
  }
`;

function Models(props: { models: Array<Model>; showInPerson: boolean; views: number }) {
  return (
    <div style={{ width: '100%' }}>
      <Bar
        title="THE MODELS"
        info={[
          ['', props.models.length, props.showInPerson ? 'Model Attendees' : 'Models'],
          props.showInPerson
            ? ['Reaching', props.views.toLocaleString(), 'Viewers']
            : ['Reaching', props.views.toLocaleString(), 'Viewers'],
        ]}
      />
      <ModelContainer>
        {chunk(props.models, 3).map((obj: Array<Model>, i: number) => {
          return <ModelRow key={i} i={i} models={obj} />;
        })}
      </ModelContainer>
    </div>
  );
}

export default Models;
